var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingslarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4 13.58a2.02 2.02 0 0 1 .8 2.84l-.7 1.2a2.13 2.13 0 0 1-1.81 1.04c-.36 0-.76-.1-1.09-.3a1.63 1.63 0 0 0-.9-.23 1.9 1.9 0 0 0-1.89 1.82c0 1.15-.94 2.05-2.11 2.05h-1.4c-1.18 0-2.12-.9-2.12-2.05a1.9 1.9 0 0 0-2.78-1.59c-.33.2-.73.3-1.08.3-.74 0-1.44-.4-1.82-1.04l-.7-1.2a2 2 0 0 1-.03-2.05c.17-.3.47-.6.82-.79.29-.14.47-.37.64-.64.52-.86.2-1.99-.66-2.5a2.04 2.04 0 0 1-.76-2.83l.69-1.18a2.12 2.12 0 0 1 2.88-.76c.89.48 2.04.16 2.57-.69.16-.28.25-.58.23-.88-.02-.39.1-.76.29-1.06A2.2 2.2 0 0 1 11.27 2h1.45c.75 0 1.44.42 1.82 1.04.18.3.3.67.27 1.06-.02.3.07.6.24.88a1.97 1.97 0 0 0 2.57.69 2.11 2.11 0 0 1 2.87.76l.69 1.18c.6.99.26 2.26-.76 2.83a1.82 1.82 0 0 0-.65 2.5c.16.27.35.5.63.64ZM9.11 12.01c0 1.57 1.3 2.82 2.9 2.82a2.83 2.83 0 1 0 0-5.65c-1.6 0-2.9 1.26-2.9 2.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingslarge);
export default __webpack_public_path__ + "static/media/settings.large.f6580eebd955bf8eb2135322605964a7.svg";
export { ForwardRef as ReactComponent };